module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright © 2010 by The University Press of Kentucky")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Scholarly publisher for the Commonwealth,"), _c('br'), _vm._v("serving Bellarmine University, Berea College, Centre"), _c('br'), _vm._v("College of Kentucky, Eastern Kentucky University,"), _c('br'), _vm._v("The Filson Historical Society, Georgetown College,"), _c('br'), _vm._v("Kentucky Historical Society, Kentucky State University,"), _c('br'), _vm._v("Morehead State University, Murray State University,"), _c('br'), _vm._v("Northern Kentucky University, Transylvania University,"), _c('br'), _vm._v("University of Kentucky, University of Louisville,"), _c('br'), _vm._v("and Western Kentucky University."), _c('br'), _vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("Editorial and Sales Offices:")]), _vm._v(" The University Press of Kentucky 663 South Limestone Street, Lexington, Kentucky 40508-4008"), _c('br'), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://www.kentuckypress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kentuckypress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("14 13 12 11 10     5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Brown, Roberta Simpson, 1939-")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Spookiest stories ever: four seasons of Kentucky ghosts / Roberta Simpson Brown and Lonnie E. Brown, foreword by Elizabeth Tucker.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v(" p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("ISBN 978-0-8131-2595-4 (hardcover: alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("1. Tales—Kentucky. 2. Ghost stories, American—Kentucky. I. Brown, Lonnie E. II. Tucker, Elizabeth, 1948-III. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("GR110.K4B76 2010")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("398.209769—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "crt3"
  }, [_vm._v("2010017533")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("This book is printed on acid-free recycled paper meeting the requirements of the American National Standard for Permanence in Paper for Printed Library Materials.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/IV-1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Manufactured in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/IV-2.png"
    }
  }), _vm._v(" Member of the Association of American University Presses")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e47572","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780813173894_epub_cop_r1.vue
// module id = 63
// module chunks = 0